import { ResourceItem } from "../ResourceItem";
import { createListResource } from "../../list";
import { createFullClassResource } from "../../fullResource";
import { NameResourceItem } from "../NameResourceItem";

export class Opakowanie extends NameResourceItem {}

export const opakowanieResource = createFullClassResource(
  "plm/opakowanie/",
  Opakowanie,
);
